import React from 'react';
import {Link} from "react-router-dom";
import {Button, Col, Row} from "reactstrap";
import {useSelector} from "react-redux";
import moment from "moment";

const Profile = () => {
    const user = useSelector(state => state.auth.user);

    return (
        <div className="page page-profile">
            <h1 className="page-header">Profile</h1>

            <Row className="mb-3">
                <Col>
                    <div className="item">
                        <h4 className="item-label">Name:</h4>
                        <p className="item-value">{user.first_name} {user.middle_name} {user.last_name}</p>
                    </div>
                </Col>
                <Col>
                    <div className="item">
                        <h4 className="item-label">Email:</h4>
                        <p className="item-value">{user.email}</p>
                    </div>
                </Col>
                <Col>
                    <div className="item">
                        <h4 className="item-label">Gender:</h4>
                        <p className="item-value">{user.student.gender_translated}</p>
                    </div>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col>
                    <div className="item">
                        <h4 className="item-label">Birthdate:</h4>
                        <p className="item-value">{moment(user.student.birthdate).format('MM/DD/YYYY')}</p>
                    </div>
                </Col>

                <Col>
                    <div className="item">
                        <h4 className="item-label">Phone Number:</h4>
                        <p className="item-value">{user.student.phone_number}</p>
                    </div>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col>
                    <div className="item">
                        <h4 className="item-label">Address Line 1:</h4>
                        <p className="item-value">{user.student.address_line_1}</p>
                    </div>
                </Col>
                <Col>
                    <div className="item">
                        <h4 className="item-label">Address Line 2:</h4>
                        <p className="item-value">{user.student.address_line_2}</p>
                    </div>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col>
                    <div className="item">
                        <h4 className="item-label">City:</h4>
                        <p className="item-value">{user.student.city}</p>
                    </div>
                </Col>
                <Col>
                    <div className="item">
                        <h4 className="item-label">State:</h4>
                        <p className="item-value">{user.student.state}</p>
                    </div>
                </Col>
                <Col>
                    <div className="item">
                        <h4 className="item-label">Zip Code:</h4>
                        <p className="item-value">{user.student.zip_code}</p>
                    </div>
                </Col>
            </Row>

            {user.student.customFields && !!user.student.customFields.length &&
            <div className="row">
                {user.student.customFields.map((field, index) => {
                    return (
                        <div className="col-4" key={index}>
                            <div className="item">
                                <h4 className="item-label">{field.lookup.label}:</h4>
                                <p className="item-value">{field.value}</p>
                            </div>
                        </div>
                    );
                })}
            </div>}

            <Link to="/profile/edit">
                <Button>Edit</Button>
            </Link>
        </div>
    );
};

export default Profile;
